export const HAS_MOUNTED = "HAS_MOUNTED";

export const QUEUE_ADD = "QUEUE_ADD";
export const QUEUE_TASK_COMPLETE = "QUEUE_TASK_COMPLETE";

export const WIDGET_ADD = "WIDGET_ADD";
export const WIDGET_SEND_TO = "WIDGET_SEND_TO";

export const ROLE_RIGHT_GET = "ROLE_RIGHT_GET";
export const ROLE_RIGHT_SET = "ROLE_RIGHT_SET";

export const MACHINE_KILL = "MACHINE_KILL";
export const HORIZON_ACCESSOR_ERRORED = "HORIZON_ACCESSOR_ERRORED";

export const HELP_OPEN = "HELP_OPEN";
export const POPUP_WIDGET_OPEN = "POPUP_WIDGET_OPEN";

export const USER_SETTINGS_RESET = "USER_SETTINGS_RESET";
export const USER_SETTINGS_SAVE = "USER_SETTINGS_SAVE";

export const SIGN_COLLECTIONS_GET = "SIGN_COLLECTIONS_GET";
export const SIGN_COLLECTIONS_SET = "SIGN_COLLECTIONS_SET";

export const OCCUPANCY_SETTINGS_GET = "OCCUPANCY_SETTINGS_GET";
export const OCCUPANCY_SETTINGS_SET_CONTEXT = "OCCUPANCY_SETTINGS_SET_CONTEXT";
export const OCCUPANCY_SETTINGS_SET_DB = "OCCUPANCY_SETTINGS_SET_DB";
export const OCCUPANCY_SETTINGS_ERROR = "OCCUPANCY_SETTINGS_ERROR";

export const WIDGET_INSTANCE_SAVE = "WIDGET_INSTANCE_SAVE";

export const NO_FURTHER_ACTION = "NO_FURTHER_ACTION";
export const LOG = "LOG";
